
import * as actionTypes from './actionTypes';

export const initEquipmentStart = () => {
  return {
    type: actionTypes.INIT_EQUIPMENT_START
  };
};
export const refreshEquipment = () => {
  return window.location.reload();
};
export const setEquipment = (realEquipment) => {
  return {
    type: actionTypes.SET_EQUIPMENT,
    realEquipment:realEquipment
  };
};
export const rebootPod = (pSerial) => {
  return {
    type: actionTypes.REBOOT_POD,
    pSerial: pSerial
  };
}
export const changePod = (pSerial, nickName) => {
  return {
    type: actionTypes.CHANGE_POD,
    pSerial: pSerial,
    nickName: nickName
  };
}
export const claimPod = (pSerial, macAddress) => {
  //console.log("actions.claimPod", pSerial);
  return {
    type: actionTypes.CLAIM_POD,
    pSerial: pSerial,
    macAddress: macAddress
  };
}
export const reclaimPod = (pSerial) => {
  return {
    type: actionTypes.RECLAIM_POD,
    pSerial: pSerial
  };
}

export const setLocatePod = (locatePod) => {
  // console.log('SET LOCATE ACTION', locatePod)
  return {
    type: actionTypes.LOCATE_POD,
    locatePod: locatePod
  };
}
export const locateAllPods = () => {
  return {
    type: actionTypes.LOCATE_ALL_PODS,
  };
}

export const locatePodSuccess = () => {
  return {
    type: actionTypes.LOCATE_POD_SUCCESS
  }
}

export const locatePodFailed = () => {
  return {
    type: actionTypes.LOCATE_POD_FAILED
  }
}

export const updateLocatePod = (updateLocatePod) => {
  return {
    type: actionTypes.UPDATE_LOCATE_POD,
    updateLocatePod:updateLocatePod
  }
}

export const fetchEquipmentFailed = () => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_FAILED
  };
};
export const resetEquipmentState = () => {
  return {
    type: actionTypes.RESET_EQUIPMENT_STATE,
    
  };
}

export const fetchEquipmentSuccess = () => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_SUCCESS
  };
};
export const resetEquipmentErrorSuccess = () => {

  return {
    type: actionTypes.RESET_EQUIPMENT_ERROR_SUCCESS
  }
}

export const initSelectedEquipment = (equipment) => {

  return {
    type: actionTypes.INIT_SELECTED_EQUIPMENT,
    selectedEquipment: equipment
  }
}

export const setSelectedEquipment = (equipment) => {
  // console.log('setSelectedEquipment actions props', equipment);
  return {
    type: actionTypes.SET_SELECTED_EQUIPMENT,
    selectedEquipment: equipment?.selectedEquipment ? {...equipment?.selectedEquipment || {}} : equipment
  };
};

export const initEquipment = (equipment) => {
  return {
    type: actionTypes.INIT_EQUIPMENT,
    selectedEquipment: equipment
  };

};
export const changePodSuccess = (nickname) => {
  return {
    type: actionTypes.CHANGE_POD_SUCCESS,
    nickname
  }
}
export const changePodFailed = () => {
  return {
    type: actionTypes.CHANGE_POD_FAILED
  }
}

export const changeEquipmentName = (payload) => {
  return {
    type: actionTypes.CHANGE_POD,
    pSerial:payload.pSerial,
    nickName:payload.nickName
  }
}

export const updateEquipmentPodName = (payload) => {
  return {
    type: actionTypes.UPDATE_POD_NAME,
    data: payload
  };
}

export const changeEquipmentNameSucces = () => {
  return {
    type: actionTypes.CHANGE_EQUIPMENT_NAME_SUCCESS
  }
}

export const changeEquipmentNameFailed = () => {
  return {
    type: actionTypes.CHANGE_EQUIPMENT_NAME_FAILED
  }
}
